export default __webpack_public_path__ + "static/media/destication.09c98815.png";